import React, { ComponentProps } from 'react';
import { ProfileImage } from '../../../types/api/ImageType';
import IForm from '../../../types/IForm';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';

type ProfileImageEditProps = {
  image: ProfileImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: IForm;
};

export function ProfileImageEdit({ image, form, cropping, viewportSwitch }: ProfileImageEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('ProfileImage');

  return (
    <ImageUploadForm
      imageDescriptionName={t('imageDescriptionName')}
      cropping={cropping}
      viewportSwitch={viewportSwitch}
      form={form}
      formId="profile-image-upload-form"
      uuid={uuid}
      initialImage={image}
      refresh={refresh}
      additionalDescription={t(`additionalDescription`)}
    />
  );
}

export const ProfileImageEditView = asFetchableView(ProfileImageEdit);
export type ProfileImageEditView = ComponentProps<typeof ProfileImageEditView>;
